export enum SuppressionMode {
  AUTO = 'auto',
  MANUAL = 'manual',
  DISABLED = 'disabled',
}
